import { useCallback } from 'react';
import { manageAutoFunding } from '../../../../../wallet/utilities/api';

const useWalletSaveAutoFunding = (walletId) => {
  return useCallback(
    (config) => {
      return manageAutoFunding(walletId, config);
    },
    [walletId],
  );
};

export default useWalletSaveAutoFunding;
